// extracted by mini-css-extract-plugin
export default {"bottomTextMJ":"_footer_bottomTextMJ__cSqJR","bottomTextSouthern":"_footer_bottomTextSouthern__Y4qtw"};